// Vue plugin <svg-dynamic-calendar>:

'use strict';

const plugin = {

	install(Vue, options) {

		Vue.component('svg-dynamic-calendar', {

			template: `
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
					:title="vpTooltip"
					x="0px" y="0px" xml:space="preserve"
					viewBox="0 0 170 170"
					:style="{ stroke:color }"
					style="enable-background:new new 0 0 170 170;
						overflow: visible;
						stroke-linecap: round; stroke-linejoin: round; stroke-miterlimit: 10;
						fill: none; stroke-width: 4;
						font-family: Roboto,Arial,sans-serif; text-anchor: middle;">
					<g id="kalender-dyn-01">
						<g id="ark">
							<rect x="5" y="15" width="160" height="150" rx="5" ry="5"/>
							<line x1="125" y1="5" x2="125" y2="30"/>
							<line x1="45" y1="5" x2="45" y2="30"/>
							<line x1="5" y1="45" x2="165" y2="45"/>
						</g>
						<text id="dag" x="85" y="112.95" :style="{ fill:color }" style="stroke: none; font-size: 70px; font-weight: 300;">{{ dag }}</text>
						<text id="manad" x="85" y="146.4" :style="{ fill:color }" style="stroke: none; font-size: 24px; font-weight: 400; letter-spacing: 0.03em;">{{ manad }}</text>
					</g>
				</svg>
			`,

			/* Ang props-validering, se https://vuejs.org/v2/guide/components.html#Prop-Validation */
			props: {
				color: {
					type: String,
					default: '#000000'
				},
				time: {
					type: String,
					default: new Date().toString()	// Dagens datum
				},
				locale: {
					type: String,
					default: 'sv-se'
				},
				vpTooltip: {
					type: String,			// Får innehålla HTML.
					default: null,
				},
			},

			computed: {
				dag() {
					return (this.time === '?' ? '?' : new Date(this.time).getDate());
				},
				manad() {
					return (this.time === '?' ? '' : new Date(this.time).toLocaleString(this.locale, {month: 'long'}).toUpperCase());		//.toUpperCase(),
				}
			}
		});
	}
};

export { plugin as euiSvgDynamicCalendar };
